// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class AddInventoryEntry extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        category_list:[],
        category:'',
        category_item:'',
        category_item_list:[],
        category_size_list:[],
        is_size_available:false,
        cat_item_obj:[],
        venue_list:[],
      };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);

    }
  
  componentDidMount() {
    this.getCategoryList()
    this.getCenterList()
  }  

  getCenterList(){
    const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
          this.setState({venue_list:data.result}) 
       }).catch(error => error);
  }

  getCategoryList(){
    const url = `${getLocationOrigin()}/inventory/get_inventory_category_list/`;
    const options = {...defaultOptions};
  
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
              this.setState({category_list:data.category_list})
       }).catch(error => error);
    }

    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.value

        if(name == 'category'){
            console.log(value)
            let category_item = this.state.category_list.filter((item)=>{return item.id ==value })
            console.log('category_item')
            console.log(category_item)
            let x = [...new Set(category_item[0].category_item.map(obj => obj.name))]
            let y = [...new Set(category_item[0].category_item.map(obj => obj.size))]
            this.setState({ category:value,category_item_list:x,cat_item_obj:category_item[0].category_item,category_size_list:y})
        }

        if(name == 'category_item'){
            console.log('this.state.category_item_list')
            console.log(this.state.cat_item_obj)
            let category_size = this.state.cat_item_obj.filter((item)=>{return item.name ==value })
            console.log('category_size')
            console.log(category_size)
            if(category_size && category_size[0].size !== ''){
                this.setState({is_size_available:true})
            }
            else{
                this.setState({is_size_available:false})
            }
            this.setState({ category_item:value})
        }

        if(name == 'location'){
            this.setState({ location:value})
        }

        if(name == 'size'){
            this.setState({ size:value})
        }

        if(name == 'quantity'){
            this.setState({ quantity:value})
        }

        if(name == 'venue_list'){
            this.setState({ venue:value})
        }

    }

    updateCategoryItemEntry(){
        if(!this.state.venue){
            alert("Center is required")
        }
        else if(!this.state.category){
            alert("Category is required")
        }
        else if(!this.state.category_item){
            alert("Category item is required")
        }
        else if(!this.state.quantity){
            alert("Quantity is required")
        }
        else{
        const url = `${getLocationOrigin()}/inventory/update_inventory_entry/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                            'venue_id': this.state.venue,
                                            'category_id': this.state.category,
                                            'item':this.state.category_item,
                                            'type':this.state.size,
                                            'quantity':this.state.quantity,
                                            });
        console.log('Going to fetch');
        return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(response=>{  
            console.log('response',response)
            alert(response.message)
            // props.history.goBack();
            })
            .catch(error => {
            console.log(error);
            alert(error.message);
            });
            }
        }

    handleSubmit(event){
        event.preventDefault();
        this.updateCategoryItemEntry()
    }

    render() { 
      return(
        <div style={styles.container}>
            <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} className="col-md-12 label_blue_1">
                    <h3 style={{textAlign:'center'}}> Add Entry</h3>
                </div>
                <form  className="validated-form form-horizontal">
                <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                        Category
                        </div>
                        <select name="category"  className="col-md-6" style={styles.item_body} value={this.state.category}
                            onChange={this.handleChange} >
                            <option>-------</option>
                            {
                            this.state.category_list.map((category, index) => (
                            <option key={category.id} value={category.id}>{category.name}</option>
                            ))
                            }
                        </select>
                    </div>
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                        Item
                        </div>
                        <select name="category_item"  className="col-md-6" style={styles.item_body} value={this.state.category_item}
                            onChange={this.handleChange} >
                            <option>-------</option>
                            {
                            (this.state.category_item_list).map((category_item, index) => (
                            <option key={category_item} value={category_item}>{category_item}</option>
                            ))
                            }
                        </select>
                    </div>
                    {this.state.is_size_available &&
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                        Type
                        </div>
                        <select name="size"  className="col-md-6" style={styles.item_body} value={this.state.size}
                            onChange={this.handleChange} >
                            <option>-------</option>
                            {
                            (this.state.category_size_list).map((category_size_list, index) => (
                            <option key={category_size_list} value={category_size_list}>{category_size_list}</option>
                            ))
                            }
                        </select>
                    </div>
                    }
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                        Quantity
                        </div>
                        <input type="number" style={styles.input} name="quantity" className="required"
                          value={this.state.quantity} onChange={this.handleChange}/>
                    </div>
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                        Center
                        </div>
                        <select name="venue_list"  className="col-md-6" style={styles.item_body} value={this.state.venue}
                            onChange={this.handleChange} >
                            <option>-------</option>
                            {
                            this.state.venue_list.map((venue, index) => (
                            <option key={venue.id} value={venue.id}>{venue.name}</option>
                            ))
                            }
                        </select>
                    </div>
                    <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                        <div style={styles.button_submit} className="col-md-12">
                            <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
      );
    }
  }
  
  export default AddInventoryEntry;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addInventoryEntry/AddInventoryEntry.js